// extracted by mini-css-extract-plugin
module.exports = {"isReducedNavNavItem":"NavItem_isReducedNavNavItem__kqUAm typography_reducedNavigation__4_qzl"};